import qs from "qs";
import hbscan from "../../api/hbscan";
import {
    IPropertyGroup,
    IPropertyGroupCreate,
    IPropertyGroupUpdate,
    IUserGroup,
} from "../../models/propertyGroup";
import Auth from "../auth/AuthService";

class PropertyGroupService {
    PostPropertyGroup = async (property: IPropertyGroupCreate) => {
        const URL = `/api/hbscan/PropertyGroup/PostPropertyGroup`;
        return (
            await hbscan.post<number>(URL, JSON.stringify(property), {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    DeletePropertyGroup = async (propertyGroupId: number) => {
        const URL = `/api/hbscan/propertyGroup/DeletePropertyGroup`;
        await hbscan.delete(URL, {
            headers: { Authorization: Auth.guid },
            params: { propertyGroupId },
        });
    };

    PutPropertyGroup = async (property: IPropertyGroupUpdate) => {
        const URL = `/api/hbscan/propertyGroup/PutPropertyGroup`;
        return await hbscan.put(URL, JSON.stringify(property), {
            headers: { Authorization: Auth.guid },
        });
    };

    async GetPropertyGroups() {
        const URI = "/api/hbscan/PropertyGroup/GetPropertyGroups";
        return (
            (
                await hbscan.get<IPropertyGroup[]>(URI, {
                    headers: { Authorization: Auth.guid },
                })
            ).data || []
        );
    }

    async GetPropertyGroup(propertyGroupId: number) {
        const URI = "/api/hbscan/PropertyGroup/GetPropertyGroup";
        return (
            (
                await hbscan.get<IPropertyGroup>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { propertyGroupId },
                })
            ).data || []
        );
    }

    async GetUserGroups() {
        const URI = "/api/hbscan/PropertyGroup/GetUserGroupsByUser";
        return (
            (
                await hbscan.get<IUserGroup[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { userId: Auth.user?.id },
                })
            ).data || []
        );
    }
    async GetUserGroupsByUserId() {
        const URI = "/api/hbscan/PropertyGroup/GetUserGroupsByUser";
        return (
            (
                await hbscan.get<IUserGroup[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { userId: Auth.user?.id },
                })
            ).data || []
        );
    }

    async GetPropertyGroupsByBuildings(buildingIds: number[]) {
        const URI = "/api/hbscan/PropertyGroup/GetPropertyGroupsByBuildings";
        return (
            (
                await hbscan.get<IPropertyGroup[]>(URI, {
                    headers: { Authorization: Auth.guid },
                    params: { buildingIds },
                    paramsSerializer: (params) => {
                        return qs.stringify(params, { arrayFormat: "repeat" });
                    },
                })
            ).data || []
        );
    }
}

const propertyGroupService = new PropertyGroupService();

export default propertyGroupService;
